import { render, staticRenderFns } from "./PatientSurgeryInfo.vue?vue&type=template&id=4427fd8e&scoped=true"
import script from "./PatientSurgeryInfo.vue?vue&type=script&lang=js"
export * from "./PatientSurgeryInfo.vue?vue&type=script&lang=js"
import style0 from "./PatientSurgeryInfo.vue?vue&type=style&index=0&id=4427fd8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427fd8e",
  null
  
)

export default component.exports